
import React, { Component}  from 'react';
import ScheduleForm from "../Forms/ScheduleForm";
import { FormContext, FormProvider } from "core/FormProvider";


export default class DetailScheduleForm extends Component {

  constructor(props) {
    super(props);

    this.state = {
      isOpen: false,
      newSchedule: undefined,
      loading: false
    }
  }

  onChange = (item) => {
    this.setState({
      isOpen: true,
      newSchedule: item.start_slot
    })
  };

  handleClose = () => {
    this.setState({
      isOpen: false,
      newSchedule: undefined
    })
  }

  handleChange = (formContext, schedule, closeDialog) => {
    if (schedule) {
      formContext.setValues({
        schedule: schedule.schedule,
        driver: schedule.driver,
        tractor_unit: schedule.tractor_unit,
        semi_trailer: schedule.semi_trailer
      });
      formContext.save((item) => {
        closeDialog();
      });
    }
  };

  handlePostSave = (detailContext, item) => {
    detailContext.setItem(item);
  }

  render() {
    const { detailContext } = this.props;
    const item = detailContext.item;

    return (
      <FormProvider
        url={item.meta.url}
        postSaveMessage={'Перевозка обновлена'}
        postSave={(item) => this.handlePostSave(detailContext, item)}
        item={item}
      >
        <FormContext.Consumer>
          {formContext => {
            return (
              <React.Fragment>
                <ScheduleForm
                  context={formContext}
                  onChange={(item, closeDialog) => this.handleChange(formContext, item, closeDialog)}
                  showRemoveScheduleButton={false}
                />
              </React.Fragment>
            )
          }}
        </FormContext.Consumer>
      </FormProvider>
    )
  }
}
